import React, { useContext, useEffect, useRef, useState } from 'react';
import { getHighlight } from '../../../../apis/Ambition';
import { CompanyContext, PRINT_WIDTH } from '../';
import { fontReport } from '../../../../apis/util';

export const BrandWay = () => {
  const { companyName } = useContext(CompanyContext);
  const keys = ["history", "mission", "vision", "values"];
  const [history, setHistory] = useState();
  const [mission, setMission] = useState();
  const [vision, setVision] = useState();
  const [values, setValues] = useState();

  useEffect(() => {
    getHighlight({ key: "history", setValue: setHistory });
    getHighlight({ key: "mission", setValue: setMission });
    getHighlight({ key: "vision", setValue: setVision });
    getHighlight({ key: "values", setValue: setValues });
  }, []);
  const ref = useRef();
  const [width,setWidth] = useState(0)
  useEffect(() => {
    if (!ref.current) return; // wait for the elementRef to be available
    const resizeObserver = new ResizeObserver(() => {
      // Do what you want to do when the size of the element changes
      setWidth(ref.current.clientWidth)
    });
    resizeObserver.observe(ref.current);
    return () => resizeObserver.disconnect(); // clean up 
  }, []);
  return (
    <div className="brandway" ref={ref}>
      <h2 style={{ fontSize: fontReport(width,PRINT_WIDTH,51/PRINT_WIDTH,"px")}}>{companyName} Way</h2>
      <div className="page__body">
        <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.4/PRINT_WIDTH,"rem")}}><b>Our History</b> {history + "\n\n"}
          <b>Our Mission</b> {mission + "\n\n"}
          <b>Our Vision</b> {vision + "\n\n"}
          <b>Our Values</b> {values}</h5>
      </div>

    </div>
  );
};
